import './doodle-icons.css';

export const directionIcons = {
  'Все': 'book', 'Бестселлеры': 'trophy', 'Веб разработка': 'code',
  'CMS и Конструкторы': 'puzzle', 'Веб Дизайн': 'design',
  'Графический дизайн': 'brush', 'Видеомонтаж': 'video',
  'Искусственный интеллект': 'bot', 'Пакеты курсов': 'box'
};

// Original Doodle Icons by Khushmeen Sidhu (CC0); shared local SVG sprite.
export const DoodleIcon = ({ name, size = 24, className = '' }) => (
  <svg width={size} height={size} className={`doodle-icon ${className}`} aria-hidden="true" focusable="false">
    <use href={`/images/icons/doodle/sprite.svg?v=3#${name}`} />
  </svg>
);
